<template>
    <v-menu
        v-if="filters.length"
        :close-on-content-click="true"
        offset-y
        :transition="false"
        content-class="overflow-y-hidden dropmenu"
    >
        <template v-slot:activator="{ on }">
            <slot name="custom-add-filter" :on="on">
                <icon-button
                    :on="on"
                    icon="Plus"
                />
            </slot>
        </template>
        <v-list dense>
            <v-list-item
                v-for="(filterObj, index) in filters"
                :key="filterObj.key + index"
                :name="index"
                class="menu-list-item"
                @click="onFilterAdd(filterObj)"
            >
                <v-list-item-icon class="mr-3">
                    <icon :icon="filterObj.icon" />
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t(filterObj.label) }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
<script>
export default {
    name: "AddFilterButton",
    props: {
        filters: {
            type: Array,
            default: () => []
        },
    },
    computed: {},
    methods: {
        onFilterAdd(val) {
            this.$emit("add_filter", val);
        }
    }
};
</script>
